import { useQuery } from 'react-query';

import { getApiVersion, getFeatures } from './queries';

export const useApiVersion = () => useQuery('api', getApiVersion);
export const useFeatures = () => useQuery('gpuPassthroughEnabled', getFeatures);
